(() => {
  if (window.ksQuickShopLoaded) return;
  window.ksQuickShopLoaded = true;

  const quickShop = document.querySelector('[data-ks-quick-shop]');
  const quickContent = quickShop?.querySelector('[data-ks-quick-shop-content]');
  const sizeDrawer = document.querySelector('[data-ks-size-drawer]');
  const sizeContent = sizeDrawer?.querySelector('[data-ks-size-content]');
  let quickRequest;
  let loadedSizeGuideUrl = '';

  const closeDialog = dialog => {
    if (dialog?.open) dialog.close();
  };

  const productUrlFromCard = element => {
    const variantCard = element?.closest('product-grid-item-variant');
    const productLink = variantCard?.querySelector('a[data-grid-link]') || element?.closest('product-grid-item.ks-card')?.querySelector('a[data-grid-link]');
    if (!productLink) return '';
    const target = new URL(productLink.href, window.location.origin);
    if (variantCard?.dataset.gridItemVariant) target.searchParams.set('variant', variantCard.dataset.gridItemVariant);
    return target.toString();
  };

  async function openQuickShop(url) {
    if (!quickShop || !quickContent || !url) return;
    quickRequest?.abort();
    quickRequest = new AbortController();
    quickContent.innerHTML = `<div class="ks-quick-shop__loading" role="status">${quickShop.dataset.loadingLabel || 'Loading'}</div>`;
    if (!quickShop.open) quickShop.showModal();
    try {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', 'api-ks-quick-shop');
      const response = await fetch(target, { signal: quickRequest.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const apiContent = parsed.querySelector('[data-api-content]');
      if (!apiContent) throw new Error('Missing quick shop content');
      quickContent.replaceChildren(...apiContent.childNodes);
      quickContent.scrollTop = 0;
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(url);
    }
  }

  function applySizeGuideTarget(guide, url) {
    guide.querySelectorAll('.is-size-match').forEach(element => element.classList.remove('is-size-match'));
    const params = new URL(url, window.location.origin).searchParams;
    const gender = params.get('ks_gender');
    const category = params.get('ks_category');
    const selectedSize = params.get('ks_size');
    if (gender && guide.matches('.ks-size-guide')) {
      const genderTab = [...guide.querySelectorAll('.ks-size-guide__tabs button')].find(button => button.textContent.trim().toLowerCase() === gender);
      genderTab?.click();
    }
    if (guide.matches('.ks-apparel-guide')) {
      const genderTab = gender ? guide.querySelector(`[data-apparel-gender="${CSS.escape(gender)}"]`) : null;
      genderTab?.click();
      if (category) {
        const normalizeCategory = value => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        const aliases = {
          'short-sleeve-tops': ['short-sleeve-tops', 'short-sleeve-top', 'short-sleeve', 'tops', 't-shirts', 't-shirt', 'polo'],
          'sleeveless': ['sleeveless', 'tank-tops', 'tank-top', 'singlets'],
          'long-sleeve-tops': ['long-sleeve-tops', 'long-sleeve-top', 'long-sleeve', 'sweatshirts', 'hoodies'],
          shorts: ['shorts', 'bottoms'],
          pants: ['pants', 'trousers', 'bottoms']
        };
        const wanted = normalizeCategory(category);
        const candidates = aliases[wanted] || [wanted];
        const categoryTab = [...guide.querySelectorAll('[data-apparel-category]')].find(button => {
          const label = normalizeCategory(button.dataset.categoryLabel || button.textContent);
          return candidates.some(candidate => label === candidate || label.includes(candidate) || candidate.includes(label));
        });
        categoryTab?.click();
      }
    }
    if (!selectedSize) return;
    const normalize = value => value.toLowerCase().replace(/^(men'?s?|women'?s?)\s+/, '').replace(/^us\s+/, '').replace(/\s+/g, '').trim();
    const selected = normalize(selectedSize);
    const activePanel = guide.querySelector('.ks-size-guide__panel:not([hidden]), [data-apparel-panel]:not([hidden])') || guide;
    const match = [...activePanel.querySelectorAll('[data-size-cell]')].find(cell => normalize(cell.textContent) === selected);
    if (!match) return;
    const matchedRow = match.closest('tr');
    (matchedRow || match).classList.add('is-size-match');
    (matchedRow || match).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  }

  async function openSizeGuide(url = quickShop?.dataset.sizeGuideUrl) {
    if (!sizeDrawer || !sizeContent) return;
    if (!sizeDrawer.open) sizeDrawer.showModal();
    const guideUrl = new URL(url, window.location.origin);
    const cacheUrl = new URL(guideUrl);
    cacheUrl.searchParams.delete('ks_size');
    cacheUrl.searchParams.delete('ks_gender');
    cacheUrl.searchParams.delete('ks_category');
    const cacheKey = cacheUrl.toString();
    if (loadedSizeGuideUrl === cacheKey) {
      const cachedGuide = sizeContent.querySelector('.ks-size-guide, .ks-apparel-guide');
      if (cachedGuide) applySizeGuideTarget(cachedGuide, url);
      return;
    }
    sizeContent.innerHTML = `<div class="ks-quick-shop__loading" role="status">${quickShop?.dataset.loadingLabel || 'Loading'}</div>`;
    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const guide = parsed.querySelector('.ks-size-guide, .ks-apparel-guide');
      if (!guide) throw new Error('Missing size guide');
      sizeContent.replaceChildren(guide);
      loadedSizeGuideUrl = cacheKey;
      applySizeGuideTarget(guide, url);
    } catch (error) {
      window.location.assign(url);
    }
  }

  document.addEventListener('click', event => {
    const productPageLink = event.target.closest('product-grid-item.ks-card a[href]');
    if (productPageLink && !productPageLink.matches('[data-ks-quick-shop-link]') && !productPageLink.closest('.ks-card__actions')) {
      event.stopImmediatePropagation();
      return;
    }
    const closeQuick = event.target.closest('[data-ks-quick-shop-close]');
    if (closeQuick) {
      closeDialog(quickShop);
      return;
    }
    const closeSize = event.target.closest('[data-ks-size-close]');
    if (closeSize) {
      closeDialog(sizeDrawer);
      return;
    }
    const colorLink = event.target.closest('[data-ks-quick-shop-color]');
    if (colorLink) {
      event.preventDefault();
      openQuickShop(colorLink.href);
      return;
    }
    const sizeGuideLink = event.target.closest('[data-ks-size-guide-link]');
    if (sizeGuideLink) {
      event.preventDefault();
      const isProductGuide = sizeGuideLink.hasAttribute('data-ks-product-guide');
      const selector = sizeGuideLink.closest('[data-option-position]');
      const selectedSize = isProductGuide
        ? selector?.querySelector('input[type="radio"]:checked, input[data-popout-input], select')?.value
        : quickShop?.querySelector('[data-ks-size-option][aria-checked="true"]')?.textContent.trim();
      const product = isProductGuide ? sizeGuideLink : quickShop?.querySelector('[data-ks-quick-shop-product]');
      const target = new URL(sizeGuideLink.href, window.location.origin);
      if (selectedSize) target.searchParams.set('ks_size', selectedSize);
      if (product?.dataset.productGender) target.searchParams.set('ks_gender', product.dataset.productGender);
      if (product?.dataset.productCategory) target.searchParams.set('ks_category', product.dataset.productCategory);
      openSizeGuide(target.toString());
      return;
    }
    const sizeOption = event.target.closest('[data-ks-size-option]');
    if (sizeOption && !sizeOption.disabled) {
      const form = sizeOption.closest('[data-ks-quick-shop-form]');
      form.querySelectorAll('[data-ks-size-option]').forEach(button => {
        button.setAttribute('aria-checked', button === sizeOption ? 'true' : 'false');
      });
      form.querySelector('[data-ks-variant-id]').value = sizeOption.dataset.variantId;
      const submit = form.querySelector('[data-ks-quick-shop-submit]');
      submit.disabled = false;
      submit.querySelector('[data-ks-submit-label]').textContent = form.dataset.addLabel;
      return;
    }
    const guideTab = event.target.closest('.ks-size-drawer .ks-size-guide__tabs button');
    if (guideTab) {
      const guide = guideTab.closest('.ks-size-guide');
      const targetId = guideTab.getAttribute('aria-controls');
      guide.querySelectorAll('.ks-size-guide__tabs button').forEach(button => {
        const active = button === guideTab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      guide.querySelectorAll('.ks-size-guide__panel').forEach(panel => {
        panel.hidden = panel.id !== targetId;
      });
      return;
    }
    const apparelGenderTab = event.target.closest('.ks-size-drawer [data-apparel-gender]');
    const apparelCategoryTab = event.target.closest('.ks-size-drawer [data-apparel-category]');
    if (apparelGenderTab || apparelCategoryTab) {
      const guide = (apparelGenderTab || apparelCategoryTab).closest('[data-ks-apparel-guide]');
      const panels = [...guide.querySelectorAll('[data-apparel-panel]')];
      let gender = guide.dataset.activeGender || 'men';
      let category = guide.dataset.activeCategory || '0';
      if (apparelGenderTab) {
        gender = apparelGenderTab.dataset.apparelGender;
        const firstAvailable = panels.find(panel => panel.dataset.gender === gender);
        if (firstAvailable) category = firstAvailable.dataset.category;
      }
      if (apparelCategoryTab) category = apparelCategoryTab.dataset.apparelCategory;
      guide.dataset.activeGender = gender;
      guide.dataset.activeCategory = category;
      guide.querySelectorAll('[data-apparel-gender]').forEach(tab => tab.setAttribute('aria-selected', String(tab.dataset.apparelGender === gender)));
      guide.querySelectorAll('[data-apparel-category]').forEach(tab => tab.setAttribute('aria-selected', String(tab.dataset.apparelCategory === category)));
      panels.forEach(panel => { panel.hidden = panel.dataset.gender !== gender || panel.dataset.category !== category; });
      return;
    }
    const sharedTrigger = event.target.closest('[data-ks-quick-shop-link]');
    if (sharedTrigger && quickShop) {
      event.preventDefault();
      openQuickShop(sharedTrigger.href || sharedTrigger.dataset.ksQuickShopLink);
      return;
    }
    const card = event.target.closest('product-grid-item.ks-card');
    if (!card || !quickShop) return;
    const quickButton = event.target.closest('[data-ks-card-quick-shop]');
    if (!quickButton) return;
    if (quickButton?.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openQuickShop(productUrlFromCard(quickButton));
  }, true);

  quickShop?.addEventListener('click', event => {
    if (event.target === quickShop) closeDialog(quickShop);
  });
  sizeDrawer?.addEventListener('click', event => {
    if (event.target === sizeDrawer) closeDialog(sizeDrawer);
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ks-quick-shop-form]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[data-ks-quick-shop-submit]');
    const label = submit.querySelector('[data-ks-submit-label]');
    const errorNode = form.querySelector('[data-ks-quick-shop-error]');
    if (!form.querySelector('[data-ks-variant-id]').value) return;
    submit.disabled = true;
    label.textContent = form.dataset.addingLabel;
    errorNode.hidden = true;
    try {
      const response = await fetch(window.theme?.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.errorLabel);
      const lookDrawer = document.querySelector('.ks-look__drawer[open]');
      closeDialog(quickShop);
      const cartCount = document.querySelector('[data-header-cart-count]');
      if (cartCount) {
        const nextCount = Number(cartCount.textContent || 0) + Number(result.quantity || 1);
        cartCount.textContent = `${nextCount}`;
        cartCount.setAttribute('data-header-cart-count', `${nextCount}`);
      }
      if (lookDrawer) {
        const popdown = document.querySelector('[data-product-add-popdown-wrapper]');
        if (popdown) lookDrawer.querySelector('.ks-look__drawer-panel')?.append(popdown);
      }
      document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: { id: result.id } }, bubbles: true }));
      try {
        const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
        if (!cartResponse.ok) throw new Error(String(cartResponse.status));
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        if (cartCount) {
          cartCount.textContent = `${cart.item_count}`;
          cartCount.setAttribute('data-header-cart-count', `${cart.item_count}`);
        }
      } catch (cartRefreshError) {
        console.warn('Cart was updated, but its display could not be refreshed.', cartRefreshError);
      }
    } catch (error) {
      errorNode.textContent = error.message || form.dataset.errorLabel;
      errorNode.hidden = false;
      submit.disabled = false;
      label.textContent = form.dataset.addLabel;
    }
  });

  const money = cents => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.theme?.currencyCode || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${window.theme?.currencyCode || ''}`.trim();
    }
  };

  const escapeHtml = value => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  async function renderRecommendations(cart) {
    const holder = document.querySelector('[data-ks-cart-recommendations]');
    if (!holder || !cart?.items?.length) {
      if (holder) holder.hidden = true;
      return;
    }
    const productId = cart.items[0].product_id;
    const limit = Number(holder.dataset.limit || 6);
    try {
      const endpoint = `${window.theme.routes.product_recommendations_url}.json?product_id=${encodeURIComponent(productId)}&limit=${limit}&intent=complementary`;
      const response = await fetch(endpoint);
      const data = await response.json();
      const cartIds = new Set(cart.items.map(item => Number(item.product_id)));
      const products = (data.products || []).filter(product => !cartIds.has(Number(product.id))).slice(0, limit);
      if (!products.length) {
        holder.hidden = true;
        return;
      }
      const list = holder.querySelector('[data-ks-cart-recommendations-list]');
      list.innerHTML = products.map(product => {
        const featuredImage = product.featured_image || product.images?.[0] || '';
        const image = typeof featuredImage === 'string' ? featuredImage : featuredImage.url || featuredImage.src || '';
        const price = product.price || product.variants?.[0]?.price || 0;
        return `<a class="ks-cart-recommendation" href="${escapeHtml(product.url)}" data-ks-recommendation-link><img src="${escapeHtml(image)}" alt="" loading="lazy"><span class="ks-cart-recommendation__info"><span class="ks-cart-recommendation__title">${escapeHtml(product.title)}</span><span class="ks-cart-recommendation__price">${escapeHtml(money(Number(price)))}</span></span></a>`;
      }).join('');
      holder.hidden = false;
    } catch (error) {
      holder.hidden = true;
    }
  }

  document.addEventListener('theme:cart:change', event => renderRecommendations(event.detail?.cart));
  document.addEventListener('theme:cart:change', event => {
    const count = document.querySelector('[data-ks-cart-title-count]');
    if (count && event.detail?.cart) count.textContent = `(${event.detail.cart.item_count})`;
  });
  if (document.querySelector('[data-ks-cart-recommendations]')) {
    fetch(`${window.theme.routes.cart}.js`).then(response => response.json()).then(renderRecommendations).catch(() => {});
  }
})();
